import { render, staticRenderFns } from "./addHouse.vue?vue&type=template&id=0f706b5f&scoped=true&"
import script from "./addHouse.vue?vue&type=script&lang=js&"
export * from "./addHouse.vue?vue&type=script&lang=js&"
import style0 from "./addHouse.vue?vue&type=style&index=0&id=0f706b5f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f706b5f",
  null
  
)

export default component.exports